import PropTypes from "prop-types";

function Loading({size = "2x"}) {
  return (
    <div className="text-center">
      <i className={`fa fa-spinner fa-spin fa-${size}`} />
    </div>
  );
}

Loading.propTypes = {size: PropTypes.string};

export default Loading;
